/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { AlarmService } from './AlarmService';

class AlarmServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new AlarmService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { AlarmServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/service/AlarmServiceProvider.js